import { ElementRef, Injectable, QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NavbarStatus } from './navigation.service';
import {
  BUYER_APP_COLL_URL,
  BUYER_APP_DEV_URL,
  BUYER_APP_LOCAL_URL,
  BUYER_APP_PROD_URL,
  COLL_STAGE,
  DEV_STAGE,
  LOCAL_USERNAME_KEY,
  LOGO_PLACEHOLDER_SRC,
  PROD_STAGE,
  LastStatusChangeType,
} from '../shared/constants/operationals';
import { CompanyContract, CompanyContractStatus } from './company-contracts.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ACCEPTED_LABEL,
  ARCHIVED_LABEL,
  DENIED_LABEL,
  DISABLED_LABEL,
  ENABLED_LABEL,
  PARTIALLY_ENABLED_LABEL,
  GENERAL_COPIED_SUCCESS_MESSAGE,
  IN_STORE_SALES_LABEL,
  OFF_SESSION_SALES_LABEL,
  ON_SESSION_SALES_LABEL,
  ORDER_STATUS_CANCELED_LABEL,
  ORDER_STATUS_COMPLETED_LABEL,
  ORDER_STATUS_PENDING_LABEL,
  ORDER_STATUS_REFUNDED_LABEL,
  ORDER_STATUS_RUNNING_LABEL,
  ORDER_STATUS_STORE_REVIEW_LABEL,
  ORDER_STATUS_ARCHIVED_LABEL,
  PENDING_ACCEPTANCE_LABEL,
  PENDING_EVALUATION_LABEL,
  PENDING_SIGNATURE_LABEL,
  WEB_SALES_LABEL,
  DEL_POS_LABEL,
  DEL_NEG_LABEL,
  SHOPIFY_LABEL,
  MAGENTO_LABEL,
  OTHER_LABEL,
  PRESTASHOP_LABEL,
  WOOCOMMERCE_LABEL,
  VBAN_STATUS_PARTIALLY_FUNDED_LABEL,
  VBAN_STATUS_PENDING_LABEL,
  VBAN_STATUS_SUCCEEDED_LABEL,
  UNPAID_STATUS_CANCELED_LABEL,
  UNPAID_STATUS_EXPIRED_LABEL,
  UNPAID_STATUS_PENDING_LABEL,
  UNPAID_STATUS_RECOVERED_LABEL,
  PRODUCT_CATEGORY_CLOTHING_LABEL,
  PRODUCT_CATEGORY_COSMETICS_BEAUTY_LABEL,
  PRODUCT_CATEGORY_DENTAL_CLINICS_LABEL,
  PRODUCT_CATEGORY_FURNITURE_LABEL,
  PRODUCT_CATEGORY_MEDICAL_PRACTICES_LABEL,
  PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS_LABEL,
  PRODUCT_CATEGORY_OPTICIANS_LABEL,
  PRODUCT_CATEGORY_SPORTING_GOODS_LABEL,
  PRODUCT_CATEGORY_VETERINARIANS_LABEL,
  PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS_LABEL,
  PRODUCT_CATEGORY_PROFESSIONAL_SERVICES_LABEL,
  PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES_LABEL,
  PRODUCT_CATEGORY_HEARING_AIDS_LABEL,
  PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE_LABEL,
  PRODUCT_CATEGORY_INSURANCE_LABEL,
  PRODUCT_CATEGORY_BICYCLES_LABEL,
  PRODUCT_CATEGORY_BODYWORK_LABEL,
  PRODUCT_CATEGORY_FURNITURE_ACCESSORIES_LABEL,
  PRODUCT_CATEGORY_DEALERS_LABEL,
  PRODUCT_CATEGORY_DOOR_TO_DOOR_LABEL,
  PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT_LABEL,
  PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY_LABEL,
  PRODUCT_CATEGORY_TRAINING_AND_COURSES_LABEL,
  PRODUCT_CATEGORY_TIRE_DEALERS_LABEL,
  PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS_LABEL,
  PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS_LABEL,
  PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS_LABEL,
  PRODUCT_CATEGORY_GYMS_LABEL,
  PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES_LABEL,
  PRODUCT_CATEGORY_ENERGY_RENOVATION_LABEL,
  PRODUCT_CATEGORY_DOORS_AND_WINDOWS_LABEL,
  PRODUCT_CATEGORY_STOVES_AND_FIREPLACES_LABEL,
  PRODUCT_CATEGORY_LEISURE_LABEL,
  WEB_OFF_SESSION_SALES_LABEL,
  BUYER_IN_ORDER_SALES_LABEL,
  BUYER_IN_STORE_SALES_LABEL,
  BUYER_IN_WEBSITE_SALES_LABEL,
  SALES_CHANNEL_STORE_AND_ECOMMERCE_LABEL,
  SALES_CHANNEL_ECOMMERCE_LABEL,
  SALES_CHANNEL_STORE_LABEL,
  ORIGIN_LOANS_LABEL,
  ORIGIN_DIRECT_LABEL,
  ORIGIN_MTP_LABEL,
  TAX_DEDUCTION_BM_LABEL,
  TAX_DEDUCTION_CT_LABEL,
  TAX_DEDUCTION_IS_LABEL,
  TAX_DEDUCTION_RE_LABEL,
  TAX_DEDUCTION_RS_LABEL,
  ORDER_STEP_COMPLETED_LABEL,
  ORDER_STEP_REFUNDED_LABEL,
  ORDER_STEP_CANCELED_LABEL,
  BUYER_STRIPE_PAYMENT_SOURCE_LABEL,
  PRE_AUTHORIZATION_AT_LABEL,
  CANCELED_AT_LABEL,
  COMPLETED_AT_LABEL,
  CONTRACT_ID_LABEL,
  CREATED_AT_LABEL,
  FEA_CONTRACT_ID_LABEL,
  READY_FOR_LIQUIDATION_AT_LABEL,
  REFUNDED_AT_LABEL,
  RUNNING_AT_LABEL,
  PENDING_AT_LABEL,
  EXPERIAN_VERIFICATION_LABEL,
  TAX_DEDUCTION_TC_LABEL,
  VOP_REQUEST_SUCCEEDED_LABEL,
  VOP_REQUEST_FAILED_LABEL,
  VOP_REQUEST_PENDING_LABEL,
  VOP_REQUEST_FL_CALL_LABEL,
  VOP_REQUEST_LF_CALL_LABEL,
  VOP_REQUEST_TAX_CODE_CALL_LABEL,
  VOP_REQUEST_MTCH_LABEL,
  VOP_REQUEST_CMTC_LABEL,
  VOP_REQUEST_NMTC_LABEL,
} from '../shared/constants/translations';
import { SharedCopySnackbarComponent } from '../shared/shared-copy-snackbar/shared-copy-snackbar.component';
import { environment } from 'src/environments/environment';
import {
  Channel,
  Currency,
  ListOrdersParams,
  Order,
  OrderStatus,
  Origin,
  BDResult,
  TaxDeductionType,
  VbanStatus,
} from './orders.service';
import { Step, StepStatus } from './steps.service';
import {
  AllowedDeductionType,
  Company,
  CompanyOrigin,
  CompanyProductCategory,
  CompanyStatus,
} from './companies.service';
import { CmsValue, Store } from './stores.service';
import { Buyer, BuyerOrigin } from './buyers.service';
import { Country } from './countries.service';
import { LongRange } from './long-range.service';
import { ListUnpaidParams, UnpaidStatus } from './unpaid.service';
import { SellerInvitationRole } from './seller-invitations.service';
import { Refund } from './refund.service';
import { VopRequest, VopRequestMostSimilarCall, VopRequestResult, VopRequestStatus } from './vop-request.service';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor(private snackbar: MatSnackBar) {}

  getCountryPrefixFromCode(country_prefixes: Country[], code: string): Country {
    return country_prefixes.filter(cp => {
      return cp.code == code;
    })[0];
  }

  hasPssLengthError(form_group: FormGroup, password_label: string): boolean | undefined {
    return (
      form_group.get(password_label)?.hasError('minlength') && !form_group.get(password_label)?.hasError('required')
    );
  }

  hasPssPatternError(form_group: FormGroup, password_label: string): boolean | undefined {
    return (
      form_group.get(password_label)?.hasError('pattern') &&
      !form_group.get(password_label)?.hasError('minlength') &&
      !form_group.get(password_label)?.hasError('required')
    );
  }

  getPssFormFieldErrorClass(
    form_group: FormGroup,
    password_label: string,
  ): {
    [key: string]: boolean | undefined;
  } {
    return {
      'sp-form-field__with-error':
        this.hasPssLengthError(form_group, password_label) || this.hasPssPatternError(form_group, password_label),
      '': !this.hasPssLengthError(form_group, password_label) && !this.hasPssPatternError(form_group, password_label),
    };
  }

  getStepZeroMaxPercFormFieldErrorClass(
    form_group: FormGroup,
    step_0_tax_percentage: string,
  ): {
    [key: string]: boolean | undefined;
  } {
    return {
      'sp-form-field__with-error': this.hasStepZeroMaxPercError(form_group, step_0_tax_percentage),
      '': !this.hasStepZeroMaxPercError(form_group, step_0_tax_percentage),
    };
  }

  hasStepZeroMaxPercError(form_group: FormGroup, step_0_tax_percentage: string): boolean | undefined {
    return form_group.get(step_0_tax_percentage)?.hasError('min');
  }

  getNavbarClass(navbar_status: NavbarStatus): { [key: string]: boolean | undefined } {
    return {
      'sp-page__with-navbar-open': navbar_status == NavbarStatus.open,
      'sp-page__with-navbar-closed': navbar_status == NavbarStatus.closed,
    };
  }

  getProfileShrinkedUsername(): string {
    const username: string | null = localStorage.getItem(LOCAL_USERNAME_KEY);
    if (username) {
      return `${username[0]}${username[1]}`;
    }
    return '';
  }

  getProfileEmail(): string {
    const email: string | null = localStorage.getItem(LOCAL_USERNAME_KEY);
    if (email) return email;
    return '';
  }

  getCompanyStatusBackgroundClass(company: Company): { [key: string]: boolean } {
    return {
      'sp-background__status-400': company.status == CompanyStatus.pending_evaluation,
      'sp-background__status-100': company.status == CompanyStatus.pending_signature,
      'sp-background__status-200': company.status == CompanyStatus.pending_acceptance,
      'sp-background__status-50': company.status == CompanyStatus.accepted,
      'sp-background__status-300': company.status == CompanyStatus.denied,
      'sp-background__status-500': company.status == CompanyStatus.archived,
      'sp-background__status-800': company.is_partially_enabled == true,
    };
  }

  getVopRequestStatusBackgroundClass(vop_request: VopRequest): { [key: string]: boolean } {
    return {
      'sp-background__status-50': vop_request.status == VopRequestStatus.succeeded,
      'sp-background__status-300': vop_request.status == VopRequestStatus.failed,
      'sp-background__status-800': vop_request.status == VopRequestStatus.pending,
    };
  }

  getStoreStatusBackgroundClass(store: Store): { [key: string]: boolean | undefined } {
    return {
      'sp-background__status-50': store.order_requirements?.is_enabled,
      'sp-background__status-200': store.order_requirements?.is_partially_enabled,
      'sp-background__status-300':
        !store.order_requirements ||
        (!store.order_requirements.is_enabled && !store.order_requirements.is_partially_enabled),
    };
  }

  getCompanySettingsBackgroundClass(settings: boolean): { [key: string]: boolean } {
    return {
      'sp-background__status-50': settings,
      'sp-background__status-400': !settings,
    };
  }

  getContractStatusBackgroundClass(contract: CompanyContract): { [key: string]: boolean } {
    return {
      'sp-background__status-50': contract.status == CompanyContractStatus.accepted,
      'sp-background__status-100': contract.status == CompanyContractStatus.pending,
      'sp-background__status-200': contract.status == CompanyContractStatus.signed,
      'sp-background__status-300': contract.status == CompanyContractStatus.denied,
    };
  }

  getDeductionTypeLabel(allowed_deduction_type?: AllowedDeductionType): string {
    switch (allowed_deduction_type) {
      case AllowedDeductionType.bonus_mobili:
        return TAX_DEDUCTION_BM_LABEL;
      case AllowedDeductionType.conto_termico:
        return TAX_DEDUCTION_CT_LABEL;
      case AllowedDeductionType.conto_termico_3:
        return TAX_DEDUCTION_TC_LABEL;
      case AllowedDeductionType.interventi_sismici:
        return TAX_DEDUCTION_IS_LABEL;
      case AllowedDeductionType.riqualifica_edilizia:
        return TAX_DEDUCTION_RE_LABEL;
      case AllowedDeductionType.risparmio_energetico:
        return TAX_DEDUCTION_RS_LABEL;
      default:
        return '-';
    }
  }

  getContractStatusColorClass(contract: CompanyContract): { [key: string]: boolean } {
    return {
      'sp-color__accent-contrast':
        contract.status == CompanyContractStatus.accepted ||
        contract.status == CompanyContractStatus.pending ||
        contract.status == CompanyContractStatus.denied,
      'sp-color__primary': contract.status == CompanyContractStatus.signed,
    };
  }

  copyClick(content?: string): void {
    if (content) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(content).then(() => {
          this.showSnackbar(GENERAL_COPIED_SUCCESS_MESSAGE, 'check_circle_outlined');
        });
      } else {
        const text_area = document.createElement('textarea');
        text_area.value = content;
        document.body.appendChild(text_area);
        text_area.focus();
        text_area.select();

        try {
          const successful = document.execCommand('copy');
          if (successful) {
            this.showSnackbar(GENERAL_COPIED_SUCCESS_MESSAGE, 'check_circle_outlined');
          }
        } catch (err) {}
        document.body.removeChild(text_area);
      }
    }
  }

  showSnackbar(message: string, icon: string): void {
    this.snackbar.openFromComponent(SharedCopySnackbarComponent, {
      duration: 2 * 1000,
      data: { message, icon },
    });
  }

  getShrinkedID(extended_id?: string): string {
    if (!extended_id) {
      return '-';
    }

    if (extended_id.includes('_')) {
      const index: number = extended_id.indexOf('_');
      return `${extended_id.substring(0, index + 1)}${extended_id.substring(extended_id.length - 8)}`;
    }

    if (extended_id.includes('-')) {
      if (extended_id.length > 30) {
        return extended_id.slice(0, 13) + ' ... ' + extended_id.slice(-14);
      }
      return extended_id;
    }

    if (extended_id.length > 30) {
      return extended_id.substring(0, 27) + '...';
    }

    return extended_id;
  }

  getStoreLogo(logo_url?: string): string {
    return logo_url && logo_url !== 'icon.png'
      ? `https://${environment.STORE_BUCKET_NAME}.s3.amazonaws.com/${logo_url}`
      : LOGO_PLACEHOLDER_SRC;
  }

  getChannelLabel(channel?: Channel): string {
    switch (channel) {
      case Channel.on_session:
        return ON_SESSION_SALES_LABEL;
      case Channel.off_session:
        return OFF_SESSION_SALES_LABEL;
      default:
        return '-';
    }
  }

  getOriginLabel(origin?: Origin, channel?: Channel): string {
    switch (origin) {
      case Origin.in_store:
        return IN_STORE_SALES_LABEL;
      case Origin.web:
        if (channel === Channel.on_session) {
          return WEB_SALES_LABEL;
        } else if (channel === Channel.off_session) {
          return WEB_OFF_SESSION_SALES_LABEL;
        } else {
          return '-';
        }
      default:
        return '-';
    }
  }

  getBuyerOriginLabel(origin?: BuyerOrigin): string {
    switch (origin) {
      case BuyerOrigin.in_store:
        return BUYER_IN_STORE_SALES_LABEL;
      case BuyerOrigin.website:
        return BUYER_IN_WEBSITE_SALES_LABEL;
      case BuyerOrigin.in_order:
        return BUYER_IN_ORDER_SALES_LABEL;
      default:
        return '-';
    }
  }

  getTaxDeductionLabel(tax_deduction?: TaxDeductionType): string {
    switch (tax_deduction) {
      case TaxDeductionType.bonus_mobili:
        return TAX_DEDUCTION_BM_LABEL;
      case TaxDeductionType.conto_termico:
        return TAX_DEDUCTION_CT_LABEL;
      case TaxDeductionType.conto_termico_3:
        return TAX_DEDUCTION_TC_LABEL;
      case TaxDeductionType.interventi_sismici:
        return TAX_DEDUCTION_IS_LABEL;
      case TaxDeductionType.riqualifica_edilizia:
        return TAX_DEDUCTION_RE_LABEL;
      case TaxDeductionType.risparmio_energetico:
        return TAX_DEDUCTION_RS_LABEL;
      default:
        return '-';
    }
  }

  getBDLabel(bd?: BDResult): string {
    switch (bd) {
      case BDResult.del_pos:
        return DEL_POS_LABEL;
      case BDResult.del_neg:
        return DEL_NEG_LABEL;
      default:
        return '-';
    }
  }

  getOrderStatusClass(status?: OrderStatus): string {
    switch (status) {
      case OrderStatus.completed:
        return 'sp-orders__status-completed';
      case OrderStatus.running:
        return 'sp-orders__status-running';
      case OrderStatus.refunded:
        return 'sp-orders__status-refunded';
      case OrderStatus.pending:
        return 'sp-orders__status-pending';
      case OrderStatus.store_review:
        return 'sp-orders__status-store-review';
      case OrderStatus.canceled:
        return 'sp-orders__status-canceled';
      case OrderStatus.archived:
        return 'sp-orders__status-archived';
      default:
        return '';
    }
  }

  getStepStatusClass(status: StepStatus): string {
    switch (status) {
      case StepStatus.completed:
        return 'sp-orders__status-completed';
      case StepStatus.refunded:
        return 'sp-orders__status-refunded';
      case StepStatus.pending:
        return 'sp-orders__status-pending';
      case StepStatus.canceled:
        return 'sp-orders__status-canceled';
      default:
        return '';
    }
  }

  getUnpaidStatusClass(status: UnpaidStatus): string {
    switch (status) {
      case UnpaidStatus.recovered:
        return 'sp-orders__status-completed';
      case UnpaidStatus.expired:
        return 'sp-orders__status-refunded';
      case UnpaidStatus.pending:
        return 'sp-orders__status-pending';
      case UnpaidStatus.canceled:
        return 'sp-orders__status-canceled';
      default:
        return '';
    }
  }

  getUnpaidStatusLabel(status?: UnpaidStatus): string {
    switch (status) {
      case UnpaidStatus.pending:
        return UNPAID_STATUS_PENDING_LABEL;
      case UnpaidStatus.expired:
        return UNPAID_STATUS_EXPIRED_LABEL;
      case UnpaidStatus.recovered:
        return UNPAID_STATUS_RECOVERED_LABEL;
      case UnpaidStatus.canceled:
        return UNPAID_STATUS_CANCELED_LABEL;
      default:
        return '';
    }
  }

  getStepStatusLabel(status?: StepStatus): string {
    switch (status) {
      case StepStatus.pending:
        return UNPAID_STATUS_PENDING_LABEL;
      case StepStatus.completed:
        return ORDER_STEP_COMPLETED_LABEL;
      case StepStatus.refunded:
        return ORDER_STEP_REFUNDED_LABEL;
      case StepStatus.canceled:
        return ORDER_STEP_CANCELED_LABEL;
      default:
        return '';
    }
  }

  getCompanyStatusLabel(status: CompanyStatus, is_partially_enabled?: boolean): string {
    if (is_partially_enabled) {
      return PARTIALLY_ENABLED_LABEL;
    }

    switch (status) {
      case CompanyStatus.pending_evaluation:
        return PENDING_EVALUATION_LABEL;
      case CompanyStatus.pending_signature:
        return PENDING_SIGNATURE_LABEL;
      case CompanyStatus.pending_acceptance:
        return PENDING_ACCEPTANCE_LABEL;
      case CompanyStatus.accepted:
        return ACCEPTED_LABEL;
      case CompanyStatus.denied:
        return DENIED_LABEL;
      case CompanyStatus.archived:
        return ARCHIVED_LABEL;
      case CompanyStatus.partially_enabled:
        return PARTIALLY_ENABLED_LABEL;
      default:
        return '';
    }
  }

  getCompanySalesChannelLabel(sales_channel: string): string {
    switch (sales_channel) {
      case 'store':
        return SALES_CHANNEL_STORE_LABEL;
      case 'ecommerce':
        return SALES_CHANNEL_ECOMMERCE_LABEL;
      case 'store_and_ecommerce':
        return SALES_CHANNEL_STORE_AND_ECOMMERCE_LABEL;
      default:
        return '-';
    }
  }

  getCompanyProductCategoryLabel(product_category: CompanyProductCategory): string {
    switch (product_category) {
      case CompanyProductCategory.clothing:
        return PRODUCT_CATEGORY_CLOTHING_LABEL;
      case CompanyProductCategory.cosmetics_beauty:
        return PRODUCT_CATEGORY_COSMETICS_BEAUTY_LABEL;
      case CompanyProductCategory.dental_clinics:
        return PRODUCT_CATEGORY_DENTAL_CLINICS_LABEL;
      case CompanyProductCategory.furniture:
        return PRODUCT_CATEGORY_FURNITURE_LABEL;
      case CompanyProductCategory.musical_instruments:
        return PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS_LABEL;
      case CompanyProductCategory.opticians:
        return PRODUCT_CATEGORY_OPTICIANS_LABEL;
      case CompanyProductCategory.sporting_goods:
        return PRODUCT_CATEGORY_SPORTING_GOODS_LABEL;
      case CompanyProductCategory.veterinarians:
        return PRODUCT_CATEGORY_VETERINARIANS_LABEL;
      case CompanyProductCategory.professional_services:
        return PRODUCT_CATEGORY_PROFESSIONAL_SERVICES_LABEL;
      case CompanyProductCategory.medical_practices:
        return PRODUCT_CATEGORY_MEDICAL_PRACTICES_LABEL;
      case CompanyProductCategory.tv_telephony_and_electronics:
        return PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS_LABEL;
      case CompanyProductCategory.real_estate_agencies:
        return PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES_LABEL;
      case CompanyProductCategory.hearing_aids:
        return PRODUCT_CATEGORY_HEARING_AIDS_LABEL;
      case CompanyProductCategory.home_and_bathroom_furniture:
        return PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE_LABEL;
      case CompanyProductCategory.insurance:
        return PRODUCT_CATEGORY_INSURANCE_LABEL;
      case CompanyProductCategory.bicycles:
        return PRODUCT_CATEGORY_BICYCLES_LABEL;
      case CompanyProductCategory.bodywork:
        return PRODUCT_CATEGORY_BODYWORK_LABEL;
      case CompanyProductCategory.furniture_accessories:
        return PRODUCT_CATEGORY_FURNITURE_ACCESSORIES_LABEL;
      case CompanyProductCategory.dealers:
        return PRODUCT_CATEGORY_DEALERS_LABEL;
      case CompanyProductCategory.door_to_door:
        return PRODUCT_CATEGORY_DOOR_TO_DOOR_LABEL;
      case CompanyProductCategory.diy_and_home_improvement:
        return PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT_LABEL;
      case CompanyProductCategory.physiotherapy_osteopathy:
        return PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY_LABEL;
      case CompanyProductCategory.training_and_courses:
        return PRODUCT_CATEGORY_TRAINING_AND_COURSES_LABEL;
      case CompanyProductCategory.tire_dealers:
        return PRODUCT_CATEGORY_TIRE_DEALERS_LABEL;
      case CompanyProductCategory.home_alarm_systems:
        return PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS_LABEL;
      case CompanyProductCategory.car_alarm_systems:
        return PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS_LABEL;
      case CompanyProductCategory.car_motorcycle_repair_shops:
        return PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS_LABEL;
      case CompanyProductCategory.gyms:
        return PRODUCT_CATEGORY_GYMS_LABEL;
      case CompanyProductCategory.bed_bases_and_mattresses:
        return PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES_LABEL;
      case CompanyProductCategory.energy_renovation:
        return PRODUCT_CATEGORY_ENERGY_RENOVATION_LABEL;
      case CompanyProductCategory.doors_and_windows:
        return PRODUCT_CATEGORY_DOORS_AND_WINDOWS_LABEL;
      case CompanyProductCategory.stoves_and_fireplaces:
        return PRODUCT_CATEGORY_STOVES_AND_FIREPLACES_LABEL;
      case CompanyProductCategory.leisure:
        return PRODUCT_CATEGORY_LEISURE_LABEL;
      case CompanyProductCategory.other:
        return OTHER_LABEL;
      default:
        return '';
    }
  }

  getCompanyOriginLabel(origin: CompanyOrigin): string {
    switch (origin) {
      case CompanyOrigin.loans:
        return ORIGIN_LOANS_LABEL;
      case CompanyOrigin.direct:
        return ORIGIN_DIRECT_LABEL;
      case CompanyOrigin.mtp:
        return ORIGIN_MTP_LABEL;
      default:
        return '';
    }
  }

  getCMSLabel(cms: CmsValue): string {
    switch (cms) {
      case CmsValue.magento:
        return MAGENTO_LABEL;
      case CmsValue.prestashop:
        return PRESTASHOP_LABEL;
      case CmsValue.woocommerce:
        return WOOCOMMERCE_LABEL;
      case CmsValue.shopify:
        return SHOPIFY_LABEL;
      case CmsValue.other:
        return OTHER_LABEL;
      default:
        return '';
    }
  }

  getStoreStatusLabel(store: Store): string {
    if (store.order_requirements?.is_enabled) return ENABLED_LABEL;
    if (store.order_requirements?.is_partially_enabled) return PARTIALLY_ENABLED_LABEL;
    return DISABLED_LABEL;
  }

  getBuyerAppBasePath(stage: string): string {
    switch (stage) {
      case PROD_STAGE:
        return BUYER_APP_PROD_URL;
      case COLL_STAGE:
        return BUYER_APP_COLL_URL;
      case DEV_STAGE:
        return BUYER_APP_DEV_URL;
      default:
        return BUYER_APP_LOCAL_URL;
    }
  }

  getVopRequestStatusLabel(status: VopRequestStatus): string {
    switch (status) {
      case VopRequestStatus.succeeded:
        return VOP_REQUEST_SUCCEEDED_LABEL;
      case VopRequestStatus.failed:
        return VOP_REQUEST_FAILED_LABEL;
      case VopRequestStatus.pending:
        return VOP_REQUEST_PENDING_LABEL;
      default:
        return '';
    }
  }

  getVopRequestMostSimilarCallLabel(most_similar_call: VopRequestMostSimilarCall): string {
    switch (most_similar_call) {
      case VopRequestMostSimilarCall.fl_call:
        return VOP_REQUEST_FL_CALL_LABEL;
      case VopRequestMostSimilarCall.lf_call:
        return VOP_REQUEST_LF_CALL_LABEL;
      case VopRequestMostSimilarCall.tax_code_call:
        return VOP_REQUEST_TAX_CODE_CALL_LABEL;
      default:
        return '';
    }
  }

  getVopRequestResultLabel(result: VopRequestResult): string {
    switch (result) {
      case VopRequestResult.MTCH:
        return VOP_REQUEST_MTCH_LABEL;
      case VopRequestResult.CMTC:
        return VOP_REQUEST_CMTC_LABEL;
      case VopRequestResult.NMTC:
        return VOP_REQUEST_NMTC_LABEL;
      default:
        return '';
    }
  }

  getBuyerAppLinkFromStore(store: Store): string {
    let url = ``;
    const subdomain = store.company_custom_buyer_subdomain ? store.company_custom_buyer_subdomain + '.' : '';

    const stage = environment.STAGE.replaceAll(' ', '').toLowerCase();

    /*
    console.log('getBuyerAppLinkFromStore()');
    console.log(`STAGE: ${environment.STAGE}`);
    console.log(`STAGE prepared: ${stage}`);
    console.log(`subdomain: ${subdomain}`);
    console.log(`foo${environment.STAGE}bar`);
    */

    if (stage == 'prod') {
      url = `https://${subdomain}buyers.splittypay.com/#/auth/signin?store_id=${store.store_id}&store_name=${
        store.name
      }&store_logo=${this.getStoreLogo(store.logo_url)}`;
    } else if (stage == 'coll') {
      url = `https://${subdomain}buyers.coll.splittypay.com/#/auth/signin?store_id=${store.store_id}&store_name=${
        store.name
      }&store_logo=${this.getStoreLogo(store.logo_url)}`;
    } else if (stage == 'dev') {
      url = `https://${subdomain}buyers.dev.splittypay.com/#/auth/signin?store_id=${store.store_id}&store_name=${
        store.name
      }&store_logo=${this.getStoreLogo(store.logo_url)}`;
    } else if (stage == 'hfix') {
      url = `https://${subdomain}buyers.hfix.splittypay.com/#/auth/signin?store_id=${store.store_id}&store_name=${
        store.name
      }&store_logo=${this.getStoreLogo(store.logo_url)}`;
    } else {
      url = `http://localhost:6001/#/auth/signin?store_id=${store.store_id}&store_name=${
        store.name
      }&store_logo=${this.getStoreLogo(store.logo_url)}${
        store.company_custom_buyer_subdomain ? '&theme=' + store.company_custom_buyer_subdomain : ''
      }`;
    }

    return url.replaceAll(' ', '%20');
  }

  getBuyerAppLinkFromOrder(order: Order): string {
    let url = ``;
    const subdomain = order.company_custom_buyer_subdomain ? order.company_custom_buyer_subdomain + '.' : '';

    const stage = environment.STAGE.replaceAll(' ', '').toLowerCase();

    /*
    console.log('getBuyerAppLinkFromOrder()');
    console.log(`STAGE: ${environment.STAGE}`);
    console.log(`STAGE prepared: ${stage}`);
    console.log(`subdomain: ${subdomain}`);
    console.log(`foo${environment.STAGE}bar`);
    */

    if (stage == 'prod') {
      url = `https://${subdomain}buyers.splittypay.com/#/auth/signin?store_id=${order.store_id}&order_id=${
        order.order_id
      }&store_name=${order.store_name}&store_logo=${this.getStoreLogo(order.store_logo)}&order_amount=${
        order.amount?.total
      }`;
    } else if (stage == 'coll') {
      url = `https://${subdomain}buyers.coll.splittypay.com/#/auth/signin?store_id=${order.store_id}&order_id=${
        order.order_id
      }&store_name=${order.store_name}&store_logo=${this.getStoreLogo(order.store_logo)}&order_amount=${
        order.amount?.total
      }`;
    } else if (stage == 'dev') {
      url = `https://${subdomain}buyers.dev.splittypay.com/#/auth/signin?store_id=${order.store_id}&order_id=${
        order.order_id
      }&store_name=${order.store_name}&store_logo=${this.getStoreLogo(order.store_logo)}&order_amount=${
        order.amount?.total
      }`;
    } else if (stage == 'hfix') {
      url = `https://${subdomain}buyers.hfix.splittypay.com/#/auth/signin?store_id=${order.store_id}&order_id=${
        order.order_id
      }&store_name=${order.store_name}&store_logo=${this.getStoreLogo(order.store_logo)}&order_amount=${
        order.amount?.total
      }`;
    } else {
      url = `http://localhost:6001/#/auth/signin?store_id=${order.store_id}&order_id=${order.order_id}&store_name=${
        order.store_name
      }&store_logo=${this.getStoreLogo(order.store_logo)}&order_amount=${order.amount?.total}${
        order.company_custom_buyer_subdomain ? '&theme=' + order.company_custom_buyer_subdomain : ''
      }`;
    }

    return url.replaceAll(' ', '%20');
  }

  getOrderStatusLabel(status?: OrderStatus): string {
    if (!status) return '';
    switch (status) {
      case OrderStatus.canceled:
        return ORDER_STATUS_CANCELED_LABEL;
      case OrderStatus.store_review:
        return ORDER_STATUS_STORE_REVIEW_LABEL;
      case OrderStatus.pending:
        return ORDER_STATUS_PENDING_LABEL;
      case OrderStatus.running:
        return ORDER_STATUS_RUNNING_LABEL;
      case OrderStatus.completed:
        return ORDER_STATUS_COMPLETED_LABEL;
      case OrderStatus.refunded:
        return ORDER_STATUS_REFUNDED_LABEL;
      case OrderStatus.archived:
        return ORDER_STATUS_ARCHIVED_LABEL;
      default:
        return status;
    }
  }

  getVbanStatusLabel(status?: VbanStatus): string {
    if (!status) return '';
    switch (status) {
      case VbanStatus.partially_funded:
        return VBAN_STATUS_PARTIALLY_FUNDED_LABEL;
      case VbanStatus.succeeded:
        return VBAN_STATUS_SUCCEEDED_LABEL;
      case VbanStatus.pending:
        return VBAN_STATUS_PENDING_LABEL;
      default:
        return status;
    }
  }

  getCurrencyLabelFromOrder(order: Order): string {
    switch (order.amount?.currency) {
      case Currency.eur:
        return '€';
      case Currency.dol:
        return '$';
      default:
        return '';
    }
  }

  getCurrencyLabelFromStep(step: Step): string {
    switch (step.amount?.currency) {
      case Currency.eur:
        return '€';
      case Currency.dol:
        return '$';
      default:
        return '';
    }
  }

  getCurrencyLabelFromRefund(refund: Refund): string {
    switch (refund.amount?.currency) {
      case Currency.eur:
        return '€';
      case Currency.dol:
        return '$';
      default:
        return '';
    }
  }

  getCurrencyLabelFromString(currency: string): string {
    switch (currency) {
      case Currency.eur:
        return '€';
      case Currency.dol:
        return '$';
      default:
        return '';
    }
  }

  isFilterKeySet(filters: ListOrdersParams, key: string): boolean {
    if (!filters) return false;
    if (key in filters) {
      const value = filters[key as keyof typeof filters];
      return value != null;
    }
    return false;
  }

  isFilterUnpaidKeySet(filters: ListUnpaidParams, key: string): boolean {
    if (!filters) return false;
    if (key in filters) {
      const value = filters[key as keyof typeof filters];
      return value != null;
    }
    return false;
  }

  CSVtoJSON(csv: string): any[] {
    const lines = csv.split('\n').filter(line => line.trim() !== '');
    if (lines.length === 0) return [];

    const headers = lines[0].split(',').map(h => h.trim().replace(/[\r"]/g, ''));
    const result: any[] = [];

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (line === '') continue;

      const values = line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

      if (values.length !== headers.length) {
        console.warn(`Skipping malformed CSV line: ${line}`);
        continue;
      }

      for (const value of values) {
        const trimmed_value = value.trim();
        if (!trimmed_value.startsWith('"') || !trimmed_value.endsWith('"')) {
          throw new Error(
            'Il file CSV non è conforme alla codifica attesa (RFC 4180). Tutti i campi devono essere racchiusi in double quote.',
          );
        }
      }

      const obj: any = {};
      for (let j = 0; j < headers.length; j++) {
        const raw_value = values[j].trim();
        obj[headers[j]] = raw_value.slice(1, -1).replace(/""/g, '"');
      }
      result.push(obj);
    }

    return result;
  }

  getOnboardingStatus(buyer: Buyer): string {
    if (buyer.on_boarding_steps?.contract_signed_at) {
      return 'contract signed';
    }

    if (buyer.on_boarding_steps?.fea_contract_signed_at) {
      return 'fea contract signed';
    }

    if (buyer.on_boarding_steps?.communication_channel_set_at) {
      return 'comm. channel set';
    }

    if (buyer.on_boarding_steps?.consensus_terms_set_at) {
      return 'terms set';
    }

    if (buyer.on_boarding_steps?.aml_set_at) {
      return 'aml set';
    }

    if (
      buyer.on_boarding_steps?.experian_verification_succeeded_at ||
      buyer.on_boarding_steps?.fourthline_verification_succeeded_at
    ) {
      return 'kyc verified';
    }

    if (buyer.on_boarding_steps?.phone_verified_at) {
      return 'phone set';
    }

    return '-';
  }

  getFormGroupControls(): number[] {
    return Array.from({ length: 6 }, (_, i) => i + 1);
  }

  moveToNext(event: any, current_index: number, form_group: FormGroup, otp?: QueryList<ElementRef>): boolean {
    const input = event.target as HTMLInputElement;
    let value = input.value.charAt(0); // Mantieni solo il primo carattere
    const control_name = `otp_${current_index}`;

    // Se l'indice corrente è 0 e sono incollati 6 caratteri, gestisci l'incolla completo
    if (current_index === 0 && input.value.length === 6 && /^\d{6}$/.test(input.value)) {
      Array.from(input.value).forEach((char, i) => {
        form_group.get(`otp_${i}`)?.setValue(char);
      });

      // Imposta il focus sull'ultimo input
      this.setActiveInput(5, form_group);
      this.focusInput(5, otp);
      return true;
    }

    // Verifica se il valore è numerico, altrimenti resettalo
    if (isNaN(Number(value))) {
      form_group.get(control_name)?.setValue('');
      return false;
    }

    form_group.get(control_name)?.setValue(value);

    // Gestisci la navigazione in avanti o indietro
    const next_index = value && current_index < 5 ? current_index + 1 : current_index;
    const prev_index = !value ? current_index - 1 : next_index;

    if (current_index > 0 && event instanceof KeyboardEvent && (event.key === 'Delete' || event.key === 'Backspace')) {
      this.setActiveInput(prev_index, form_group);
      this.focusInput(prev_index, otp);
      form_group.get(`otp_${prev_index}`)?.setValue('');
    } else if (value) {
      this.setActiveInput(next_index, form_group);
      this.focusInput(next_index, otp);
      if (current_index == 5) {
        return true;
      }
    }
    return false;
  }

  moveToPrev(event: KeyboardEvent, index: number, form_group: FormGroup, otp?: QueryList<ElementRef>): boolean {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      const response = this.moveToNext(event, index, form_group, otp);
      return response;
    }
    return false;
  }

  pasteOtp(event: ClipboardEvent, current_index: number, form_group: FormGroup, otp?: QueryList<ElementRef>): boolean {
    const pasted_text = (event.clipboardData?.getData('text') || '').replace(/\s+/g, '');

    // Blocca l'azione se il testo incollato non è esattamente di 6 cifre numeriche
    if (!/^\d{6}$/.test(pasted_text)) {
      event.preventDefault();
      return false;
    }

    event.preventDefault(); // Blocca l'inserimento predefinito

    // Popola i campi OTP
    Array.from(pasted_text).forEach((char, i) => {
      if (i + current_index < 6) {
        form_group.get(`otp_${current_index + i}`)?.setValue(char);
      }
    });

    // Imposta focus all'input successivo
    const next_index = Math.min(current_index + pasted_text.length, 5);
    this.setActiveInput(next_index, form_group);
    this.focusInput(next_index, otp);
    return true;
  }

  focusInput(index: number, otp?: QueryList<ElementRef>): void {
    otp?.get(index)?.nativeElement.focus();
  }

  setActiveInput(index: number, form_group: FormGroup): number {
    this.getFormGroupControls().forEach((_, i) => {
      const control = form_group.get(`otp_${i}`);
      control?.[i === index ? 'enable' : 'disable']();
    });

    return index;
  }

  getOtpValue(form_group: FormGroup): string {
    return Array.from({ length: 6 }, (_, i) => form_group.get(`otp_${i}`)?.value || '').join('');
  }

  getLongRangeLabel(long_range: LongRange): { min_label: number; max_label: number } {
    const long_range_labels = {
      min_label: long_range.min_amount as number,
      max_label: long_range.max_amount as number,
    };

    if (long_range_labels.min_label === 0) {
      long_range_labels.min_label = 200;
    }

    if (long_range_labels.max_label < 5000) {
      long_range_labels.max_label = long_range_labels.max_label - 0.01;
    }

    return long_range_labels;
  }

  getSellerInvitationRoleLabel(role: SellerInvitationRole): string {
    switch (role) {
      case SellerInvitationRole.admin:
        return 'admin';
      case SellerInvitationRole.analyst:
        return 'analyst';
      case SellerInvitationRole.store_manager:
        return 'store manager';
      case SellerInvitationRole.store_seller:
        return 'store seller';
      default:
        return '-';
    }
  }

  getSellerInvitationRoleClass(role: SellerInvitationRole): string {
    switch (role) {
      case SellerInvitationRole.admin:
        return 'sp-roles__admin';
      case SellerInvitationRole.analyst:
        return 'sp-roles__analyst';
      case SellerInvitationRole.store_manager:
        return 'sp-roles__store-manager';
      case SellerInvitationRole.store_seller:
        return 'sp-roles__store-seller';
    }
  }

  getLastOrderStatusChange(last_status_change: string | undefined): string {
    switch (last_status_change) {
      case LastStatusChangeType.CREATED_AT:
        return CREATED_AT_LABEL;
      case LastStatusChangeType.EXPERIAN_VERIFICATION:
        return EXPERIAN_VERIFICATION_LABEL;
      case LastStatusChangeType.BUYER_STRIPE_PAYMENT_SOURCE:
        return BUYER_STRIPE_PAYMENT_SOURCE_LABEL;
      case LastStatusChangeType.PRE_AUTHORIZATION_AT:
        return PRE_AUTHORIZATION_AT_LABEL;
      case LastStatusChangeType.FEA_CONTRACT_ID:
        return FEA_CONTRACT_ID_LABEL;
      case LastStatusChangeType.CONTRACT_ID:
        return CONTRACT_ID_LABEL;
      case LastStatusChangeType.COMPLETED_AT:
        return COMPLETED_AT_LABEL;
      case LastStatusChangeType.CANCELED_AT:
        return CANCELED_AT_LABEL;
      case LastStatusChangeType.REFUNDED_AT:
        return REFUNDED_AT_LABEL;
      case LastStatusChangeType.READY_FOR_LIQUIDATION_AT:
        return READY_FOR_LIQUIDATION_AT_LABEL;
      case LastStatusChangeType.RUNNING_AT:
        return RUNNING_AT_LABEL;
      case LastStatusChangeType.PENDING_AT:
        return PENDING_AT_LABEL;
      default:
        return last_status_change || '-';
    }
  }
}
